import React from "react";
import WasteGenerated from "./WasteGenerated";
import Scope3Layout from "../../../Layout/Scope3Layout";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../context/AuthContext";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
const Waste = () => {
   const{user}=useUser();
  return (
    <MainDashboardLayout sidebar={user?.groupManager?<GroupAdminSidebar/>:<Scope3Layout />}>
      <Unauthorized requiredModule="Environment | Scope 3 | Waste generated">
        <WasteGenerated />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Waste;
